import React, { useState } from 'react';
import Header from './Header';
import dayjs from 'dayjs';
import API_URL from '../config';
import * as XLSX from 'xlsx';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { supabase } from '../supabaseClient';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
ChartJS.register(ChartDataLabels);

const tipos = [
  { value: '', label: 'Todos' },
  { value: 1, label: 'Crédito à Vista' },
  { value: 2, label: 'Crédito Parcelado' },
  { value: 3, label: 'Crédito Parcelado Emissor' },
  { value: 4, label: 'Débito' },
  { value: 6, label: 'Pix' },
  { value: 10, label: 'Vale Alimentação' },
  { value: 11, label: 'Vale Refeição' },
  { value: 12, label: 'Vale Presente' },
  { value: 13, label: 'Vale Combustível' },
  { value: 50, label: 'ConexãoPIX' },
];
const statusList = [
  { value: '', label: 'Todos' },
  { value: 0, label: 'Aberto' },
  { value: 1, label: 'Autorizado' },
  { value: 2, label: 'Falha' },
  { value: 3, label: 'Negado' },
  { value: 4, label: 'Cancelado' },
  { value: 5, label: 'Arquivado' },
  { value: 6, label: 'Estornado' },
  { value: 9, label: 'Em Processamento' },
  { value: 51, label: 'Cancelamento Solicitado' },
];

function RelatorioMobtefPlanilhaPage({ usuario, empresaSelecionada, handleVoltar, handleSair }) {
  const [filtros, setFiltros] = useState({
    emissaoIni: dayjs().format('YYYY-MM-DD'),
    emissaoFim: dayjs().format('YYYY-MM-DD'),
    tipo: '',
    status: '',
    bandeira: '',
    usuario: '',
  });
  const [dados, setDados] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [mostrarResumo, setMostrarResumo] = useState(null);

  const handleChange = e => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const pesquisar = async () => {
    setCarregando(true);
    setMostrarResumo(null);
    console.log('empresaSelecionada:', empresaSelecionada);
    console.log('Chaves:', Object.keys(empresaSelecionada || {}));
    if (String(empresaSelecionada.interface) === '8') {
      // Buscar do Supabase
      let query = supabase.from('prod_tef').select('*').eq('empresa_id', empresaSelecionada.id);
      if (filtros.emissaoIni) query = query.gte('emissao', filtros.emissaoIni);
      if (filtros.emissaoFim) query = query.lte('emissao', filtros.emissaoFim);
      if (filtros.tipo) query = query.eq('tipo', filtros.tipo);
      if (filtros.status) query = query.eq('status', filtros.status);
      if (filtros.bandeira) query = query.ilike('bandeira', `%${filtros.bandeira}%`);
      if (filtros.usuario) query = query.eq('usuario_id', filtros.usuario);
      const { data, error } = await query;
      console.log('Supabase data:', data, 'error:', error);
      if (error) {
        setDados([]);
        setCarregando(false);
        return;
      }
      setDados(Array.isArray(data) ? data : []);
      setCarregando(false);
      return;
    }
    let url = `${API_URL}/tef/relatorio?empresa_id=${empresaSelecionada.id}`;
    if (filtros.emissaoIni) url += `&data_ini=${filtros.emissaoIni}`;
    if (filtros.emissaoFim) url += `&data_fim=${filtros.emissaoFim}`;
    if (filtros.tipo) url += `&tipo=${filtros.tipo}`;
    if (filtros.status) url += `&status=${filtros.status}`;
    if (filtros.bandeira) url += `&bandeira=${filtros.bandeira}`;
    if (filtros.usuario) url += `&usuario_id=${filtros.usuario}`;
    const resp = await fetch(url);
    const data = await resp.json();
    setDados(Array.isArray(data) ? data : []);
    console.log('dados MobTEF:', data);
    setCarregando(false);
  };

  const exportar = () => {
    const wsData = [
      ['ID', 'Pedido', 'Emissão', 'Tipo', 'Valor', 'Status', 'Autorização', 'NSU', 'Bandeira', 'Arquivado', 'Usuário', 'Adquirente'],
      ...dados.map(l => [
        l.id, l.pedido_id, dayjs(l.emissao).format('DD/MM/YYYY HH:mm'), mapTipo(l.tipo), l.valor, mapStatus(l.status), l.autorizacao, l.nsu, l.bandeira, l.arquivado, l.usuario_id, l.plataforma || '-'
      ])
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Relatório');
    XLSX.writeFile(wb, 'relatorio_mobtef.xlsx');
  };

  // Funções auxiliares para nomes descritivos
  const mapTipo = (tipo) => {
    const tipos = {
      1: 'Crédito à Vista',
      2: 'Crédito Parcelado',
      3: 'Crédito Parcelado Emissor',
      4: 'Débito',
      6: 'Pix',
      10: 'Vale Alimentação',
      11: 'Vale Refeição',
      12: 'Vale Presente',
      13: 'Vale Combustível',
      50: 'ConexãoPIX',
    };
    return tipos[tipo] || tipo;
  };
  const mapStatus = (status) => {
    const statusMap = {
      0: 'Aberto',
      1: 'Autorizado',
      2: 'Falha',
      3: 'Negado',
      4: 'Cancelado',
      5: 'Arquivado',
      6: 'Estornado',
      9: 'Em Processamento',
      51: 'Cancelamento Solicitado',
    };
    return statusMap[status] || status;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresaSelecionada} onVoltar={handleVoltar} onSair={handleSair} />
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-5xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-4">MobTEF Planilha</h2>
          {/* Filtros em card */}
          <div className="w-full bg-blue-50 rounded-lg p-4 mb-6 border flex flex-wrap gap-4 items-end">
            <div>
              <label className="block text-xs font-semibold text-gray-600">Emissão Inicial</label>
              <input type="date" name="emissaoIni" value={filtros.emissaoIni} onChange={handleChange} className="border rounded px-2 py-1" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Emissão Final</label>
              <input type="date" name="emissaoFim" value={filtros.emissaoFim} onChange={handleChange} className="border rounded px-2 py-1" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Tipo</label>
              <select name="tipo" value={filtros.tipo} onChange={handleChange} className="border rounded px-2 py-1">
                {tipos.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Status</label>
              <select name="status" value={filtros.status} onChange={handleChange} className="border rounded px-2 py-1">
                {statusList.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Bandeira</label>
              <input type="text" name="bandeira" value={filtros.bandeira} onChange={handleChange} className="border rounded px-2 py-1" placeholder="Todas" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600">Usuário</label>
              <input type="text" name="usuario" value={filtros.usuario} onChange={handleChange} className="border rounded px-2 py-1" placeholder="Todos" />
            </div>
            <button onClick={pesquisar} className="bg-blue-600 text-white px-4 py-2 rounded font-semibold hover:bg-blue-700 transition">Pesquisar</button>
            <button onClick={exportar} className="bg-green-600 text-white px-4 py-2 rounded font-semibold hover:bg-green-700 transition">Exportar</button>
            <button
              onClick={() => setMostrarResumo(true)}
              className={`px-4 py-2 rounded font-semibold border ml-2 ${mostrarResumo === true ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
            >Resumo</button>
            <button
              onClick={() => setMostrarResumo(false)}
              className={`px-4 py-2 rounded font-semibold border ml-2 ${mostrarResumo === false ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
            >Gráfico</button>
          </div>
          {/* Renderização condicional: grid, resumo ou gráfico */}
          {mostrarResumo === null && (
            <div className="w-full overflow-x-auto">
              <table className="min-w-full text-sm text-center border">
                <thead>
                  <tr className="bg-blue-50">
                    <th className="px-2 py-1">ID</th>
                    <th className="px-2 py-1">Pedido</th>
                    <th className="px-2 py-1">Emissão</th>
                    <th className="px-2 py-1">Tipo</th>
                    <th className="px-2 py-1">Valor</th>
                    <th className="px-2 py-1">Status</th>
                    <th className="px-2 py-1">Autorização</th>
                    <th className="px-2 py-1">Bandeira</th>
                    <th className="px-2 py-1">Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {carregando ? (
                    <tr><td colSpan={9} className="py-8 text-center">Carregando...</td></tr>
                  ) : dados.length === 0 ? (
                    <tr><td colSpan={9} className="py-8 text-center text-gray-500">Nenhum registro encontrado.</td></tr>
                  ) : (
                    dados.map(l => (
                      <tr key={l.id} className="border-b">
                        <td>{l.id}</td>
                        <td>{l.pedido_id}</td>
                        <td>{dayjs(l.emissao).format('DD/MM/YYYY HH:mm')}</td>
                        <td>{mapTipo(l.tipo)}</td>
                        <td>R$ {Number(l.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                        <td>{mapStatus(l.status)}</td>
                        <td>{l.autorizacao}</td>
                        <td>{l.bandeira}</td>
                        <td>{l.usuario_id}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
          {mostrarResumo === true && (
            <div className="w-full mt-6 mb-2">
              <div className="bg-blue-50 rounded-lg p-4 border flex flex-col gap-4">
                <h3 className="text-lg font-bold text-blue-700 mb-2">Resumo Detalhado</h3>
                {/* Totais gerais */}
                <div className="flex flex-wrap gap-8 mb-2">
                  <div>
                    <div className="text-gray-600 text-xs">Total de vendas</div>
                    <div className="text-xl font-bold text-blue-800">{dados.length}</div>
                  </div>
                  <div>
                    <div className="text-gray-600 text-xs">Valor total</div>
                    <div className="text-xl font-bold text-blue-800">R$ {dados.reduce((acc, l) => acc + Number(l.valor), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                  </div>
                </div>
                {/* Totais por status */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Status</div>
                  <div className="flex flex-wrap gap-4">
                    {Object.entries(dados.reduce((acc, l) => {
                      const status = mapStatus(l.status);
                      if (!acc[status]) acc[status] = { count: 0, valor: 0 };
                      acc[status].count++;
                      acc[status].valor += Number(l.valor);
                      return acc;
                    }, {})).map(([status, info]) => (
                      <div key={status} className="bg-white rounded px-3 py-1 shadow text-sm text-gray-700 border flex flex-col items-center">
                        <span>{status}:</span>
                        <b>{info.count} vendas</b>
                        <span className="text-blue-700 font-bold">R$ {info.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Totais por tipo */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Tipo</div>
                  <div className="flex flex-wrap gap-4">
                    {Object.entries(dados.reduce((acc, l) => {
                      const tipo = mapTipo(l.tipo);
                      if (!acc[tipo]) acc[tipo] = { count: 0, valor: 0 };
                      acc[tipo].count++;
                      acc[tipo].valor += Number(l.valor);
                      return acc;
                    }, {})).map(([tipo, info]) => (
                      <div key={tipo} className="bg-white rounded px-3 py-1 shadow text-sm text-gray-700 border flex flex-col items-center">
                        <span>{tipo}:</span>
                        <b>{info.count} vendas</b>
                        <span className="text-blue-700 font-bold">R$ {info.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Totais por bandeira */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Bandeira</div>
                  <div className="flex flex-wrap gap-4">
                    {Object.entries(dados.reduce((acc, l) => {
                      const b = l.bandeira || 'Sem Bandeira';
                      if (!acc[b]) acc[b] = { count: 0, valor: 0 };
                      acc[b].count++;
                      acc[b].valor += Number(l.valor);
                      return acc;
                    }, {})).map(([bandeira, info]) => (
                      <div key={bandeira} className="bg-white rounded px-3 py-1 shadow text-sm text-gray-700 border flex flex-col items-center">
                        <span>{bandeira}:</span>
                        <b>{info.count} vendas</b>
                        <span className="text-blue-700 font-bold">R$ {info.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Totais por usuário */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Usuário</div>
                  <div className="flex flex-wrap gap-4">
                    {Object.entries(dados.reduce((acc, l) => {
                      const u = l.usuario_id || 'Sem Usuário';
                      if (!acc[u]) acc[u] = { count: 0, valor: 0 };
                      acc[u].count++;
                      acc[u].valor += Number(l.valor);
                      return acc;
                    }, {})).map(([usuario, info]) => (
                      <div key={usuario} className="bg-white rounded px-3 py-1 shadow text-sm text-gray-700 border flex flex-col items-center">
                        <span>Usuário {usuario}:</span>
                        <b>{info.count} vendas</b>
                        <span className="text-blue-700 font-bold">R$ {info.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          {mostrarResumo === false && (
            <div className="w-full mb-8">
              <div className="bg-white rounded-lg p-4 border flex flex-col gap-6 shadow">
                <h3 className="text-lg font-bold text-blue-700 mb-2">Resumos com Gráficos</h3>
                {/* Gráfico por Status */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Status</div>
                  <Bar
                    data={{
                      labels: Object.keys(dados.reduce((acc, l) => { const s = mapStatus(l.status); acc[s] = (acc[s] || {valor:0, qtd:0}); acc[s].valor += Number(l.valor); acc[s].qtd++; return acc; }, {})),
                      datasets: [{
                        label: 'Valor (R$)',
                        data: Object.values(dados.reduce((acc, l) => { const s = mapStatus(l.status); acc[s] = (acc[s] || {valor:0, qtd:0}); acc[s].valor += Number(l.valor); acc[s].qtd++; return acc; }, {})).map(v => v.valor),
                        backgroundColor: 'rgba(37, 99, 235, 0.6)',
                        datalabels: {
                          anchor: 'center',
                          align: 'end',
                          color: '#222',
                          font: { weight: 'bold', size: 10 },
                          padding: { top: 2, bottom: 2 },
                          offset: -10,
                          formatter: (value, ctx) => {
                            const qtd = Object.values(dados.reduce((acc, l) => { const s = mapStatus(l.status); acc[s] = (acc[s] || {valor:0, qtd:0}); acc[s].valor += Number(l.valor); acc[s].qtd++; return acc; }, {}))[ctx.dataIndex]?.qtd;
                            return `${qtd} vendas\nR$ ${Number(value).toLocaleString('pt-BR', {minimumFractionDigits:2})}`;
                          }
                        }
                      }]
                    }}
                    options={{ responsive: true, plugins: { legend: { display: false }, title: { display: false }, datalabels: { display: true } } }}
                    height={80}
                  />
                </div>
                {/* Gráfico por Tipo */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Tipo</div>
                  <Bar
                    data={{
                      labels: Object.keys(dados.reduce((acc, l) => { const t = mapTipo(l.tipo); acc[t] = (acc[t] || {valor:0, qtd:0}); acc[t].valor += Number(l.valor); acc[t].qtd++; return acc; }, {})),
                      datasets: [{
                        label: 'Valor (R$)',
                        data: Object.values(dados.reduce((acc, l) => { const t = mapTipo(l.tipo); acc[t] = (acc[t] || {valor:0, qtd:0}); acc[t].valor += Number(l.valor); acc[t].qtd++; return acc; }, {})).map(v => v.valor),
                        backgroundColor: 'rgba(16, 185, 129, 0.6)',
                        datalabels: {
                          anchor: 'center',
                          align: 'end',
                          color: '#222',
                          font: { weight: 'bold', size: 10 },
                          padding: { top: 2, bottom: 2 },
                          offset: -10,
                          formatter: (value, ctx) => {
                            const qtd = Object.values(dados.reduce((acc, l) => { const t = mapTipo(l.tipo); acc[t] = (acc[t] || {valor:0, qtd:0}); acc[t].valor += Number(l.valor); acc[t].qtd++; return acc; }, {}))[ctx.dataIndex]?.qtd;
                            return `${qtd} vendas\nR$ ${Number(value).toLocaleString('pt-BR', {minimumFractionDigits:2})}`;
                          }
                        }
                      }]
                    }}
                    options={{ responsive: true, plugins: { legend: { display: false }, title: { display: false }, datalabels: { display: true } } }}
                    height={80}
                  />
                </div>
                {/* Gráfico por Bandeira */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Bandeira</div>
                  <Bar
                    data={{
                      labels: Object.keys(dados.reduce((acc, l) => { const b = l.bandeira || 'Sem Bandeira'; acc[b] = (acc[b] || {valor:0, qtd:0}); acc[b].valor += Number(l.valor); acc[b].qtd++; return acc; }, {})),
                      datasets: [{
                        label: 'Valor (R$)',
                        data: Object.values(dados.reduce((acc, l) => { const b = l.bandeira || 'Sem Bandeira'; acc[b] = (acc[b] || {valor:0, qtd:0}); acc[b].valor += Number(l.valor); acc[b].qtd++; return acc; }, {})).map(v => v.valor),
                        backgroundColor: 'rgba(234, 179, 8, 0.6)',
                        datalabels: {
                          anchor: 'center',
                          align: 'end',
                          color: '#222',
                          font: { weight: 'bold', size: 10 },
                          padding: { top: 2, bottom: 2 },
                          offset: -10,
                          formatter: (value, ctx) => {
                            const qtd = Object.values(dados.reduce((acc, l) => { const b = l.bandeira || 'Sem Bandeira'; acc[b] = (acc[b] || {valor:0, qtd:0}); acc[b].valor += Number(l.valor); acc[b].qtd++; return acc; }, {}))[ctx.dataIndex]?.qtd;
                            return `${qtd} vendas\nR$ ${Number(value).toLocaleString('pt-BR', {minimumFractionDigits:2})}`;
                          }
                        }
                      }]
                    }}
                    options={{ responsive: true, plugins: { legend: { display: false }, title: { display: false }, datalabels: { display: true } } }}
                    height={80}
                  />
                </div>
                {/* Gráfico por Adquirente */}
                <div>
                  <div className="font-semibold text-blue-700 mb-1">Por Adquirente</div>
                  <Bar
                    data={{
                      labels: Object.keys(dados.reduce((acc, l) => { let p = l.plataforma; if (!p || typeof p !== 'string' || !p.trim()) p = 'Não informado'; p = p.trim().toUpperCase(); acc[p] = (acc[p] || {valor:0, qtd:0}); acc[p].valor += Number(l.valor); acc[p].qtd++; return acc; }, {})),
                      datasets: [{
                        label: 'Valor (R$)',
                        data: Object.values(dados.reduce((acc, l) => { let p = l.plataforma; if (!p || typeof p !== 'string' || !p.trim()) p = 'Não informado'; p = p.trim().toUpperCase(); acc[p] = (acc[p] || {valor:0, qtd:0}); acc[p].valor += Number(l.valor); acc[p].qtd++; return acc; }, {})).map(v => v.valor),
                        backgroundColor: 'rgba(168, 85, 247, 0.6)',
                        datalabels: {
                          anchor: 'center',
                          align: 'end',
                          color: '#222',
                          font: { weight: 'bold', size: 10 },
                          padding: { top: 2, bottom: 2 },
                          offset: -10,
                          formatter: (value, ctx) => {
                            const qtd = Object.values(dados.reduce((acc, l) => { let p = l.plataforma; if (!p || typeof p !== 'string' || !p.trim()) p = 'Não informado'; p = p.trim().toUpperCase(); acc[p] = (acc[p] || {valor:0, qtd:0}); acc[p].valor += Number(l.valor); acc[p].qtd++; return acc; }, {}))[ctx.dataIndex]?.qtd;
                            return `${qtd} vendas\nR$ ${Number(value).toLocaleString('pt-BR', {minimumFractionDigits:2})}`;
                          }
                        }
                      }]
                    }}
                    options={{ responsive: true, plugins: { legend: { display: false }, title: { display: false }, datalabels: { display: true } } }}
                    height={80}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RelatorioMobtefPlanilhaPage; 